import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import type { PlaylistItem } from '@jwp/ott-common/types/playlist';
import { getModule } from '@jwp/ott-common/src/modules/container';
import EntitlementController from '@jwp/ott-common/src/controllers/EntitlementController';
import { isFreeItem } from '@jwp/ott-common/src/utils/entitlements';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import type { MediaProduct } from '@jwp/ott-common/types/media';
import type { Pass, Subscription } from '@jwp/ott-common/types/subscription';

const getRelatedOfferIds = (subscription: Subscription | null, passes: Pass[], mediaOffers?: MediaProduct[] | null) => {
  const offerIds: string[] = [];

  if (subscription) {
    offerIds.push(subscription.offerId);
  }

  const allContentPass = passes?.find((pass) => pass.accessScope === 'all-content');
  if (allContentPass) {
    offerIds.push(allContentPass.offerId);
  }

  if (mediaOffers?.length) {
    offerIds.push(...mediaOffers.map((offer) => offer.id));
  }

  return offerIds;
};

export default function useProtectedMedia(item: PlaylistItem) {
  const entitlementController = getModule(EntitlementController);
  const { i18n } = useTranslation();
  const { language } = i18n;
  const isFree = isFreeItem(item);
  const { subscription, passes } = useAccountStore(({ subscription, passes }) => ({ subscription, passes }));

  return useQuery({
    queryKey: ['media-signed', item.mediaid, language, !!subscription, passes.map(({ offerId }) => offerId), item.mediaOffers?.map(({ id }) => id)],
    queryFn: () => entitlementController.getSignedMedia(item.mediaid, language, {}, isFree, getRelatedOfferIds(subscription, passes, item.mediaOffers)),
    retry: 2,
    retryDelay: 1000,
  });
}
